import { makeGetRequest } from 'owa-ows-gateway';
import { getGuid } from 'owa-guid';
import { getSubstrateSearchEndpoint } from 'owa-search-service';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getSearchRequestInstrumentation } from 'owa-search-diagnostics';
import { createDefaultHeaders } from 'owa-service/lib/createDefaultHeader';

export default function donateSearchPayload(isContentDonated: boolean) {
    const searchInstrumentationEntries = getSearchRequestInstrumentation().slice();
    let latestP0LogicalId;

    searchInstrumentationEntries.forEach(instrumentation => {
        if (instrumentation.PageNumber == 0 && latestP0LogicalId == undefined) {
            latestP0LogicalId = instrumentation.SearchQueryId;
        }
    });

    sendFeedbackRequest(latestP0LogicalId, isContentDonated);
}

async function getAuthToken(resource: string): Promise<string> {
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(resource);

    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = await tokenPromise;
    }

    return token;
}

async function getHeaders(token: string): Promise<any> {
    // Create collection of headers, and initialize it with headers from fetchOptions.
    const headers = createDefaultHeaders();

    // Add ODS auth headers.
    headers['OdsAuthorization'] = 'Bearer ' + token;

    return headers;
}

function sendFeedbackRequest(logicalId: string, isContentDonated: boolean) {
    getAuthToken('https://api.diagnostics.office.com').then(token => {
        getHeaders(token).then(requestHeaders => {
            makeGetRequest(
                `${getSubstrateSearchEndpoint(
                    'feedback',
                    1
                )}?LogicalId=${logicalId}&IncludeRequest=${isContentDonated}&IncludeResponse=${isContentDonated}`,
                getGuid() /* correlationId (client-request-id) */,
                true /* returnFullResponse */,
                requestHeaders /* customHeaders */,
                true /* throwServiceError */,
                /* 3S does not need auth cookies so omitting them will decrease request header size */
                false /* IncludeCredentials */
            );
        });
    });
}
